import { pathBuilder } from 'config/paths/index';

export const root = '/admin/tags';
export default pathBuilder(root);
